__turbopack_context__.v({
  "fadeIn": "ShippingLabel-module__BqozQG__fadeIn",
  "shippingLabel": "ShippingLabel-module__BqozQG__shippingLabel",
});
